import * as ContentUI from './ContentUI'

export function replacing(collection, contentId, ui) {
  const oldUI = collection[contentId]
  if (ui === oldUI) return collection

  return {
    ...collection,
    [contentId]: ui,
  }
}

export function bySettingExpanded(uiCollection, contentId, nodeId) {
  return replacing(
    uiCollection,
    contentId,
    ContentUI.bySettingExpanded(uiCollection[contentId] ?? [], nodeId),
  )
}

export function byTogglingExpanded(uiCollection, contentId, nodeId) {
  return replacing(
    uiCollection,
    contentId,
    ContentUI.byTogglingExpanded(uiCollection[contentId] ?? [], nodeId),
  )
}
